import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import fetchZendeskSectionArticlesBySectionId, { build as SectionArticlesRequestKey } from "@faire/web-api/api/zendesk/locale/sections/sectionId/articles/get";
import { useQueries } from "@tanstack/react-query";
export var useAllSectionArticles = function useAllSectionArticles(sections) {
  var sectionArticlesResponses = useQueries({
    queries: sections.map(function (section) {
      return {
        queryKey: [SectionArticlesRequestKey(localeString, "".concat(section.id))],
        queryFn: function queryFn() {
          return fetchZendeskSectionArticlesBySectionId(localeString, "".concat(section.id));
        },
        enable: sections.length > 0 && !!section.id
      };
    })
  });
  var isLoading = sectionArticlesResponses.some(function (queryResult) {
    return queryResult.isLoading;
  });
  var allDataUpdatedAt = sectionArticlesResponses.map(function (queryResult) {
    return queryResult.dataUpdatedAt;
  });
  var dataUpdatedAt = getLatestDataUpdatedAt(allDataUpdatedAt);
  return {
    sectionArticlesResponses: sectionArticlesResponses,
    isSectionArticlesLoading: isLoading,
    sectionArticlesDataUpdatedAt: dataUpdatedAt
  };
};